import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@/components/ui/table";
import { formatCurrency } from "@/lib/utils";
import { useAppSelector } from "@/redux/store";

export default function EasiRechargeReceipt() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const state = useAppSelector((state) => state.easiRecharge);

  return (
    <section className="space-y-6 py-6">
      <h1 className="text-pretty text-center text-2xl text-muted-foreground">
        {t("receipt.title")}
      </h1>

      <Card className="mx-auto max-w-2xl">
        <CardHeader>
          <CardTitle>{t("labels.details")}</CardTitle>
        </CardHeader>
        <CardContent>
          <Table className="border">
            <TableBody>
              <TableRow className="divide-x">
                <TableHead className="h-10 bg-muted text-foreground">
                  {t("labels.mobile-number")}
                </TableHead>
                <TableCell className="py-2">{state.mobileNumber}</TableCell>
              </TableRow>
              <TableRow className="divide-x">
                <TableHead className="h-10 bg-muted text-foreground">
                  {t("labels.package")}
                </TableHead>
                <TableCell className="py-2">
                  {`Easiload ${formatCurrency(Number(state.package.price), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}`}
                </TableCell>
              </TableRow>
              <TableRow className="divide-x">
                <TableHead className="h-10 bg-muted text-foreground">
                  {t("labels.amount")}
                </TableHead>
                <TableCell className="py-2">
                  {formatCurrency(Number(state.package.price))}
                </TableCell>
              </TableRow>
              <TableRow className="divide-x">
                <TableHead className="h-10 bg-muted text-foreground">
                  {t("labels.payment-status")}
                </TableHead>
                <TableCell className="py-2">APPROVED</TableCell>
              </TableRow>
              <TableRow className="divide-x">
                <TableHead className="h-10 bg-muted text-foreground">
                  {t("labels.transaction-time")}
                </TableHead>
                <TableCell className="py-2">
                  {format(new Date(), "dd MMM yyyy, HH:mm:ss")}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
        <CardFooter>
          <Button className="w-full" onClick={() => navigate("/")}>
            {t("labels.finish")}
          </Button>
        </CardFooter>
      </Card>
    </section>
  );
}
